export class BemHelper {
  private readonly _block: string;

  constructor(block: string, prefix: string = "cr") {
    this._block = `${prefix}-${block}`;
  }

  public element(element: string): string {
    return `${this._block}__${element}`;
  }

  public modifier(modifier: string, element?: string): string {
    if (element) {
      return `${this._block}__${element}--${modifier}`;
    }
    return `${this._block}--${modifier}`
  }

  public block(): string {
    return this._block;
  }
}